import styled, { keyframes } from 'styled-components';

const theme = {
    bg: '#1C1E2A',
    surface: '#252836',
    surfaceHover: '#2d3040',
    primary: '#50fa7b',
    secondary: '#8be9fd',
    accent: '#ff79c6',
    text: '#f8f8f2',
    textSecondary: '#bd93f9',
    border: '#44475a',
    danger: '#ff5555',
};

const spinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 2rem 3rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const Header = styled.header`
  color: ${theme.text};
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  margin: 0;
  color: black;
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const Subtitle = styled.p`
  font-size: 1.1rem;
  color: ${theme.textSecondary};
  margin-top: 0.5rem;
`;

export const Controls = styled.div`
  background-color: ${theme.surface};
  padding: 1.5rem;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
`;

export const YearInput = styled.input`
  height: 50px;
  width: 150px;
  background-color: ${theme.bg};
  border: 1px solid ${theme.border};
  border-radius: 8px;
  color: ${theme.text};
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;

  &:focus {
    outline: none;
    border-color: ${theme.accent};
  }
`;

export const ActionButton = styled.button`
  padding: 0.8rem 1.8rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  border: none;
  background-color: ${theme.accent};
  color: white;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    filter: brightness(1.15);
    transform: translateY(-2px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ReportDisplay = styled.div`
  background-color: ${theme.surface};
  border-radius: 12px;
  padding: 2rem;
  margin-top: 1rem;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
`;

export const InfoMessage = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  text-align: center;
  font-size: 1.2rem;
  color: ${theme.textSecondary};
`;

export const ReportHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;

  h3 {
    font-size: 1.5rem;
    color: ${theme.text};
    margin: 0;
  }
`;

export const ClientInfo = styled.p`
    font-size: 0.9rem;
    color: ${theme.textSecondary};
    margin: 4px 0 0 0;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: ${theme.text};

  th, td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid ${theme.border};
  }

  thead th {
    color: ${theme.textSecondary};
    font-size: 0.8rem;
    text-transform: uppercase;
  }
  
  tbody tr:hover {
    background-color: ${theme.surfaceHover};
  }
  
  td:last-child {
    font-weight: 600;
    color: ${theme.primary};
  }

  tfoot {
    font-weight: bold;
    color: ${theme.primary};
    
    td {
        text-align: right;
        padding-top: 1.5rem;
        border-top: 2px solid ${theme.border};
        border-bottom: none;
    }

    td:last-child {
        font-size: 1.2rem;
    }
  }

  .spin {
    animation: ${spinAnimation} 1s linear infinite;
  }
`;